<script>
import { mapActions, mapGetters } from "vuex";
import {
  required,
  alphaNum,
  numeric,
  minLength,
  requiredIf,
} from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";

export default {
  name: "AddKiosk",
  props: ["showSite", "parentArea", "loading"],
  components: { DatePicker },
  data() {
    return {
      sitesJourney: [],
      options: [
        { text: "LamasaTech", value: "LamasaTech" },
        { text: "Partner", value: "Partner" },
      ],
      loadingAreas: false,
      isLoading: true,
      device: "",
      deviceOptions: [
        { id: "LT-Zentron8", name: "LT-Zentron8" },
        { id: "LD-AITemp", name: "LD-AITemp" },
        { id: "Zentron 15", name: "Zentron 15" },
        { id: "Zentron 5", name: "Zentron 5" },
      ],
      kioskId: null,
      name: null,
      site: null,
      siteOptions: [],
      area: null || this.parentArea,
      mac_address: null,
      lamasatech_serial: null,
      date_of_purchase: null,
      android_serial: null,
      purchased_from: "LamasaTech",
      partner_name: null,
      inherit: true,
      journey_id: "",
      submitted: false,
      checkMac: false,
    };
  },
  validations: {
    name: { required },
    area: { required },
    device: { required },
    date_of_purchase: { required },
    android_serial: {
      required,
      alphaNum,
      minLength: minLength(10),
      containsUppercase: function (value) {
        return /^[A-Z0-9]*$/.test(value);
      },
    },
    mac_address: {
      required,
      alphaNum,
      minLength: minLength(12),
      containsUppercase: function (value) {
        return /^[A-Z0-9]*$/.test(value);
      },
    },
    purchased_from: { required },
    lamasatech_serial: {
      required,
      numeric,
      minLength: minLength(14),
    },
    partner_name: {},
    journey_id: {
      required: requiredIf(function () {
        return this.inherit ? false : true;
      }),
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("sites", ["getAreas", "getSites"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("journey", ["getJourneys"]),
    disableAddBtn() {
      if (
        !this.area ||
        !this.name ||
        !this.date_of_purchase ||
        !this.mac_address ||
        !this.lamasatech_serial ||
        !this.android_serial ||
        !this.device
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    getSites(sites) {
      this.siteOptions = JSON.parse(JSON.stringify(sites));
    },
    site(site) {
      this.$store.dispatch("sites/fetchAreasBySite", site.id);
      this.fetchJourneyNormalList(site.id);
      // this.sitesJourney = site?.journeys;
    },
  },
  methods: {
    ...mapActions("sites", ["fetchAreasBySite", "fetchEntitySites"]),
    ...mapActions("kiosks", ["addKiosk"]),
    ...mapActions("journey", ["fetchJourneyNormalList"]),
    async updateAreas() {
      this.loadingAreas = true;
      await this.fetchAreasBySite(this.site.id);
      if (this.parentArea?.site_id && this.site.id == this.parentArea.site_id) {
        this.area = this.getAreas.find((area) => area.id == this.parentArea.id);
      } else {
        this.area = "";
      }
      this.loadingAreas = false;
    },
    requestAreas() {
      this.fetchJourneyNormalList(this.site.id);
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid || (!this.inherit && !this.journey_id)) return;

      // this.submitted = true;
      this.$emit(
        "addKiosk",
        {
          params: {
            kiosk: {
              name: this.name,
              area_id: this.area && this.area.id,
              entity_id: this.currentEntity.id,
              android_serial: this.android_serial,
              mac_address: this.mac_address,
              partner_name: this.partner_name,
              is_inherit: this.inherit,
              journey_id: this.journey_id
                ? this.journey_id.id
                : this.area.journey_id,
              date_of_purchase: this.date_of_purchase,
              purchased_from: this.purchased_from,
              lamasatech_serial: this.lamasatech_serial,
            },
            lamasatech_serial: {
              id: this.lamasatech_serial,
            },
          },
        },
        `addKiosk_${this.parentArea?.id}`
      );
    },
    addLamasatechSerial(selectedOption) {
      switch (selectedOption.name) {
        case "LD-AITemp":
          return (this.lamasatech_serial = "7091135919162XXXXX");
        case "LT-Zentron8":
          return (this.lamasatech_serial = "7091136435555XXXXX");
        case "Zentron 15":
          return (this.lamasatech_serial = "5060861160027XXXXX");
        case "Zentron 5":
          return (this.lamasatech_serial = "5060861161000XXXXX");
        default:
          "";
      }
    },
  },
  async beforeMount() {
    if (localStorage.getItem("mac") && localStorage.getItem("serial")) {
      this.mac_address = localStorage.getItem("mac");
      this.android_serial = localStorage.getItem("serial");
      this.checkMac = true;
      localStorage.removeItem("mac");
      localStorage.removeItem("serial");
    }
    await this.fetchEntitySites();

    if (this.parentArea?.site_id) {
      this.site = this.getSites.find(
        (site) => site.id == this.parentArea.site_id
      );
    }
    await this.fetchJourneyNormalList(this.site.id);
    this.isLoading = false;
  },
};
</script>

<template>
  <div class="kiosk-form-wrapper">
    <h4 class="allareakiosk-header">
      {{ $t("sitesAndDevices.areaActions.addKiosk") }}
    </h4>
    <b-spinner
      v-if="isLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="modal-spinner"
    />
    <div v-else>
      <div class="form-groups multi-inputs">
        <!-- site -->
        <b-form-group v-if="showSite">
          <vp-input
            v-model="site.name"
            :readOnly="true"
            label="Site"
            :disabled="true"
          />
        </b-form-group>

        <!-- area  -->
        <b-form-group>
          <vp-input
            v-model="area.name"
            :readOnly="true"
            label="Area"
            :disabled="true"
          />
        </b-form-group>

        <!-- Purchased Device -->
        <b-form-group>
          <vp-multiselect
            id="purchased_device"
            v-model="device"
            :options="deviceOptions"
            title="Purchased Device"
            placeholder="Purchased Device"
            :showPlaceholderIcon="true"
            :show-labels="false"
            :allowEmpty="true"
            label="name"
            :disabled="submitted"
            @select="addLamasatechSerial"
          />
        </b-form-group>
        <div
          class="row-group d-flex justify-content-between"
          style="width: 415px"
        >
          <!-- name   -->
          <b-form-group style="width: 200px">
            <vp-input
              v-model="$v.name.$model"
              label="Kiosk Name"
              width="200"
              :disabled="submitted"
            />
          </b-form-group>

          <b-form-group style="width: 200px">
            <date-picker
              label-cols-sm="5"
              label-cols-lg="5"
              id="date_of_purchase"
              v-model="$v.date_of_purchase.$model"
              :first-day-of-week="1"
              :disabled="submitted"
              placeholder="Purchase Date"
              :class="{
                'invalid-input': submitted && !$v.date_of_purchase.required,
              }"
            ></date-picker>

            <div
              v-if="submitted && !$v.date_of_purchase.required"
              class="invalid-feedback"
            >
              Date Of Purchase is required.
            </div>
          </b-form-group>
        </div>
        <!-- date of purchase  -->

        <!-- android serial -->
        <b-form-group class="input-icons">
          <vp-input
            v-model="$v.android_serial.$model"
            label="Android Serial Number"
            :disabled="checkMac || submitted"
          />
          <i
            :class="{
              'show-icon': !$v.android_serial.$invalid,
              'hide-icon': $v.android_serial.$invalid,
            }"
            class="icon fa fa-check"
          ></i>
          <div
            v-if="submitted && $v.android_serial.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.android_serial.required"
              >Android serial is required.</span
            >
            <span v-if="!$v.android_serial.alphaNum"
              >Please enter Android serial alphaNum.</span
            >
            <span v-if="!$v.android_serial.minLength"
              >Please enter Android serial 10 characters.</span
            >
            <span v-if="!$v.android_serial.containsUppercase"
              >Android Serial should contain capital letters only.</span
            >
          </div>
        </b-form-group>

        <!-- mac_address  -->
        <b-form-group class="input-icons">
          <vp-input
            v-model="$v.mac_address.$model"
            label="MAC Address"
            :disabled="checkMac || submitted"
          />
          <i
            :class="{
              'show-icon': !$v.mac_address.$invalid,
              'hide-icon': $v.mac_address.$invalid,
            }"
            class="icon fa fa-check"
          ></i>
          <div
            v-if="submitted && $v.mac_address.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.mac_address.required"
              >mac address is required.</span
            >
            <span v-if="!$v.mac_address.alphaNum"
              >Please enter Mac Address alphaNum.</span
            >
            <span v-if="!$v.mac_address.minLength"
              >Please enter Mac Address 12 character.</span
            >
            <span !$v.mac_address.containsUppercase
              >MAC Address should contain capital letters only.</span
            >
          </div>
        </b-form-group>
        <div class="lamasaserial-sepline"></div>

        <!-- LamasaTech Serial -->
        <b-form-group>
          <vp-input
            v-model="$v.lamasatech_serial.$model"
            label="LamasaTech Serial"
            :disabled="submitted"
          />
          <div
            v-if="submitted && !$v.lamasatech_serial.required"
            class="invalid-feedback"
          >
            LamasaTech Serial is required.
          </div>
        </b-form-group>

        <!-- purchased from  -->
        <b-form-group
          class="label-positionLogin"
          label-cols-sm="12"
          label-cols-lg="12"
          style="margin-inline-start: 22px"
          id="purchasedfrom"
          label="Purchased From:"
          label-for="purchased_from"
        >
          <div>
            <v-radio-group v-model="$v.purchased_from.$model">
              <v-radio
                v-for="option in options"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
          </div>
        </b-form-group>

        <b-form-group v-if="purchased_from == 'Partner'">
          <vp-input
            id="partner_name"
            :disabled="submitted"
            v-model="$v.partner_name.$model"
            label="Partner Name (Optional)"
          />
        </b-form-group>
        <b-form-group
          class="users-notification"
          style="margin-inline-start: 27px"
        >
          <b-form-checkbox
            :disabled="submitted"
            name="check-button"
            v-model="inherit"
            @change="journey_id = !inherit ? journey_id : ''"
            >{{ $t("sitesAndDevices.inheritJourney")}}
          </b-form-checkbox>
        </b-form-group>
        <!-- journey  -->
        <b-form-group
          v-if="!inherit"
          label-cols-sm="4"
          label-cols-lg="3"
          id="journey"
          label="Select Journey"
          label-for="journey"
        >
          <vp-multiselect
            title="Journey"
            v-model="journey_id"
            :options="getJourneys"
            :showPlaceholderIcon="true"
            :allowEmpty="true"
            :showLabels="false"
            :showOptionsBorder="true"
            label="name"
            :disabled="submitted"
          />
        </b-form-group>
      </div>
      <div class="vertical-line"></div>
      <!-- action btns  -->
      <div class="actions-btns">
        <button
          class="submit-btn btn btn-primary add-submit"
          size="md"
          @click="onSubmit"
          :disabled="submitted || loading || $v.$invalid"
        >
          <i
            v-if="submitted || loading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          Add
        </button>
        <button
          class="btn btn-outline-danger cancel-reject"
          :disabled="submitted"
          :class="{ 'cursor-stop': submitted }"
          @click="
            $bvModal.hide('addKioskGeneral_'),
              parentArea
                ? $bvModal.hide('addKiosk_' + parentArea.id)
                : $bvModal.hide('addKiosk_')
          "
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
::v-deep {
  .cursor-stop {
    cursor: not-allowed;
  }
  .show-icon {
    display: block !important;
  }
  .hide-icon {
    display: none !important;
  }
  .input-icons i {
    position: relative;
    float: inline-end;
    padding-inline-end: 15px;
  }

  .input-icons {
    width: 100%;
    margin-bottom: 10px;
  }

  .icon {
    margin-inline-end: 35px;
    margin-top: -35px;
    color: #34c38f;
    min-width: 50px;
    text-align: center;
  }

  .input-field {
    width: 100%;
    padding: 10px;
    // text-align: center;
  }

  .modal-spinner {
    width: 30px;
    height: 30px;
    top: 10px;
    position: relative;
    inset-inline-start: 231px;
    margin-bottom: 40px;
  }
}
</style>
<style lang="scss">
div#addKioskGeneral_ {
  // background: red;

  div#addKioskGeneral____BV_modal_content_ {
    width: 597px !important;
    border-radius: 26px !important;
    //position: absolute;
    div#addKioskGeneral____BV_modal_body_ {
      padding: 0px !important;
      .kiosk-form-wrapper {
        padding-top: 41px;
        padding-inline-end: 0px;
        padding-bottom: 0px;
        padding-inline-start: 46px;
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 51px;
          margin-inline-start: 0px;
          text-align: center;
        }
        .invalid-input {
          .multiselect__tags {
            border-color: #f46a6a !important;
          }
          input.mx-input {
            border-color: #f46a6a !important;
          }
        }
        .sities-con {
          padding: 0px 36px;
          input#site {
            width: 416px;
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
        }
        .multi-inputs {
          padding: 0px 36px;

          .lamasaserial-sepline {
            background: #707070;
            opacity: 0.15;
            margin-bottom: 15px;
            height: 1px;
          }
          input#site {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
          input#android_serial,
          input#mac_address,
          input#lamasatech_serial,
          input#partner_name {
            width: 416px;
          }

          input#name,
          input#android_serial,
          input#mac_address,
          input#lamasatech_serial,
          input.mx-input,
          input#partner_name {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px !important;
            border: none !important;
            outline: none !important;
            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            position: relative;
            letter-spacing: 0.25px !important;
            color: rgba(0, 0, 0, 0.87);
            padding-inline-start: 20px;
            transition: 0.6s !important;
            &::placeholder {
              font-weight: 400 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px !important;
              color: rgba(96, 96, 96, 0.87);
              opacity: 0.8;
            }
            &:focus::placeholder {
              font-weight: 700 !important;
              font-size: 12px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px;
              z-index: 99999;
              color: #103f5e !important;
              transform: translate(0px, -19px);
              opacity: 0.8;
            }
          }
          textarea.form-control {
            background: #f2f2f2 !important;
            border-radius: 4px;
            border: none !important;
            height: 105px;
          }
          textarea::placeholder {
            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            padding-inline-start: 5px;
            letter-spacing: 0.25px;

            color: rgba(96, 96, 96, 0.87);

            opacity: 0.8;
          }
          input#area,
          input#journey,
          input#purchased_device {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
          label#purchasedfrom__BV_label_ {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            margin-bottom: 27px;
            color: #787878;
          }
          label.custom-control-label {
            padding-inline-start: 20px !important;
            padding-inline-end: 40px !important;

            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            color: rgba(96, 96, 96, 0.87);
          }

          label#autoSignOut__BV_label_ {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            margin-bottom: 14px;
            letter-spacing: 0.25px;
            color: #787878;
          }
          .users-notification {
            font-weight: 400;
            font-size: 16px;
            line-height: 188.5%;
            color: #787878;
            .custom-checkbox .custom-control-label::before {
              border: 3px solid #000000 !important;
              border-radius: 3px !important;
              height: 17px !important;
              width: 17px !important;
              background-size: cover !important;
              // margin-top: 7px;
              margin-inline-end: 20px !important;
            }
            .custom-control-input:checked ~ .custom-control-label::before {
              background: #000000 !important;
              border-color: #000000 !important;
            }
          }
        }
        .actions-btns {
          margin-inline-end: 36px;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
.invalid-input {
  .multiselect__tags {
    border-color: #f46a6a !important;
  }
  input.mx-input {
    border-color: #f46a6a !important;
  }
}
div[id*="addKiosk"] {
  div[class*="modal-content"] {
    width: 579px !important;
    border-radius: 26px !important;
    div[class*="modal-body"] {
      padding: 0px !important;
      .kiosk-form-wrapper {
        padding-top: 41px;
        padding-inline-end: 0px;
        padding-bottom: 0px;
        padding-inline-start: 46px;
        .multiselect {
          width: 415px;
        }
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 51px;
          margin-inline-start: 0px;
          text-align: center;
        }
        .invalid-input {
          .multiselect__tags {
            border-color: #f46a6a !important;
          }
          input.mx-input {
            border-color: #f46a6a !important;
          }
        }
        .sities-con {
          padding: 0px 36px;
          input#site {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
        }
        .multi-inputs {
          padding: 0px 36px;
          .lamasaserial-sepline {
            background: #707070;
            opacity: 0.15;
            margin-bottom: 15px;
            height: 1px;
            width: 416px;
          }
          input#site {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
          input#android_serial,
          input#mac_address,
          input#lamasatech_serial,
          input#partner_name {
            width: 415px;
          }
          input#name,
          input#android_serial,
          input#mac_address,
          input#lamasatech_serial,
          input.mx-input,
          input#partner_name {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px !important;
            border: none !important;
            outline: none !important;
            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            position: relative;
            letter-spacing: 0.25px !important;
            color: rgba(0, 0, 0, 0.87);
            padding-inline-start: 20px;
            transition: 0.6s !important;
            &::placeholder {
              font-weight: 400 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px !important;
              color: rgba(96, 96, 96, 0.87);
              opacity: 0.8;
            }
            &:focus::placeholder {
              font-weight: 700 !important;
              font-size: 12px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px;
              z-index: 99999;
              color: #103f5e !important;
              transform: translate(0px, -19px);
              opacity: 0.8;
            }
          }
          textarea.form-control {
            background: #f2f2f2 !important;
            border-radius: 4px;
            border: none !important;
            height: 105px;
          }
          textarea::placeholder {
            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            padding-inline-start: 5px;
            letter-spacing: 0.25px;

            color: rgba(96, 96, 96, 0.87);

            opacity: 0.8;
          }
          input#area,
          input#journey,
          input#purchased_device {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
          label#purchasedfrom__BV_label_ {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            margin-bottom: 27px;
            letter-spacing: 0.25px;
            color: #787878;
          }
          label.custom-control-label {
            padding-inline-start: 20px !important;
            padding-inline-end: 40px !important;

            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            color: rgba(96, 96, 96, 0.87);
          }

          label#autoSignOut__BV_label_ {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            margin-bottom: 14px;
            letter-spacing: 0.25px;
            color: #787878;
          }
          .users-notification {
            font-weight: 400;
            font-size: 16px;
            line-height: 188.5%;
            margin-top: 37px;
            color: #787878;
            .custom-checkbox .custom-control-label::before {
              border: 3px solid #000000 !important;
              border-radius: 3px !important;
              height: 17px !important;
              width: 17px !important;
              background-size: cover !important;
              margin-inline-end: 20px !important;
            }
            .custom-control-input:checked ~ .custom-control-label::before {
              background: #000000 !important;
              border-color: #000000 !important;
            }
          }
        }
        .actions-btns {
          margin-inline-end: 36px;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
